import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Production } from 'src/app/core/interfaces/production/production';
import { ProductionManagement } from 'src/app/core/interfaces/production/production-management';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-production-management-counts-list',
  templateUrl: './production-management-counts-list.component.html',
  styleUrls: ['./production-management-counts-list.component.scss'],
})
export class ProductionManagementCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'assignedName',
    'customer',
    'jobAddress',
    'contractId',
    'createdDate',
    'reason',
    'zoneName',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  productionArray: Production[] = [];
  dataSource: MatTableDataSource<Production>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getProduction(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getProduction(this.status);
    });
  }

  getProduction(status: string) {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    if (status) {
      switch (status) {
        case 'finished':
          this.statusNumber = 1;
          this.statusMessage = 'Projects Finished';
          break;
        case 'pastDue':
          this.statusNumber = 2;
          this.statusMessage = 'Projects Past Due';
          break;
        case 'needsFollowUp':
          this.statusNumber = 4;
          this.statusMessage = 'Projects Needing Follow Up';
          break;
        case 'completed':
          this.statusNumber = 3;
          this.statusMessage = 'Projects Completed In the Last 3 Months';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService
        .getProductionManagementByStatus(this.statusNumber)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.productionArray = response;
            this.dataSource = new MatTableDataSource(this.productionArray);
            this.dataSource.sort = this.sort;
            this.dataSource.sort.sort({
              id: 'createdDate',
              start: 'desc',
              disableClear: false,
            });
            this.dataSource.paginator = this.paginator;
          },
          error: (e) => {
            this.isLoading = false;
            console.error(e);
          },
        });
    }
  }

  goToProduction(row: ProductionManagement) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        productionId: row.productionId,
        prodManagement: true,
      },
    });
  }

  filterProduction(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
